// extracted by mini-css-extract-plugin
module.exports =  {"modal":"_5UgiFazHO7XCaxoRGTQ","body":"_DCvjJbxbAQlujT73tpH","previewArea":"RLnGsMPJLtgnxlS8WNow","carouselWrapper":"tXuPXdmgf6pL61K2gqBv","sidebar":"b109Si_ZlziduCUZHrss"};